import { action, makeAutoObservable, observable } from "mobx";
import { IRootStore } from "./RootStore";
import { PassengerType } from "../services/passenger/typings/PassengerType";
import { OrganizationType } from "../components/main/body/screens/IAM/Users/types/OrganizationType";

export class PassengerStore {

  passenger:PassengerType[]=[];
  historySearchString = [];
  createPassengerOrgList: OrganizationType[] = [];
  createPassengerOrgList1: OrganizationType[] = [];
  addPassengersDetails: boolean = false;
  showMainPage:boolean=true;
  ShowChnageForm:boolean=true;
  ShowChnageEditForm:boolean=true;
  rootStore: IRootStore;
  PassengerLabel: string = "";
  passengersName:string="";
  passengersGender:string="";
  passengersSeatNumber:any="";
  passengerAge: number | null = null;
  passengerEmail:string="";
  selectedOrgId: string = "";
  selectedOrgId1:string ="";
  passengerId:string="";
  passengersContactNumber:string="";
  passengerAddress:any="";
  passengerPhysicallyDisabled:boolean=false;
  passengerPhysicallyDisabledtxt:any="";
  passengerAnyChronicDisease: boolean = false;
  passengerAnyChronicDisease1:any="";
  passengerInput0: boolean = false;
  passengerInput00:any="";
  passengerInput1:any="";
  passengerInput2:any="";
  passengerInput3:any="";
  passengerInput4: string ="";
  passengerInput5: boolean = false;
  passengerInput05:any="";
  passengerInput6: boolean = false;
  passengerInput06:any="";
  // for edit passenger

  isEditPassengerOpen: boolean = false;
  EditpassengersName:string="";
  EditpassengersGender:any="";
  EditpassengersSeatNumber:any="";
  EditpassengerAge:any="";
  EditpassengerEmail:string="";
  EditselectedOrgId: string = "";
  EditpassengersContactNumber:string="";
  EditPassengerAdress:any="";
  EditpassengerPhysicallyDisabled:boolean=false;
  EditpassengerPhysicallyDisabledans:string="";
  EditpassengerAnyChronicDisease:boolean=false;
  EditpassengerAnyChronicDisease1:any="";
  EditpassengerInput0:boolean = false;
  EditpassengerInput00:any="";
 EditpassengerInput1:string="";
  EditpassengerInput2:any="";
  EditpassengerInput3:string="";
  EditpassengerInput4:string="";
  EditpassengerInput5:boolean=false;
  EditpassengerInput05:string="";
  EditpassengerInput6:boolean=false;
  EditpassengerInput06:string="";
  update : number = 0;
  organizationList: OrganizationType[] = [];
  roleName: string = "";
  selectedOrg: number | string = "";

  constructor(rootStore: IRootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }




  handlePassengers = (passengers:   PassengerType[]) => {
    this.passenger = passengers;
}
get getPassengers() {
    return this.passenger;
}


  // Method to toggle addPassengersDetails state
  handleAddPassenger = (value: boolean) => {
    this.addPassengersDetails = value;
  };

  // Getter to access addPassengersDetails state
  get getAddPassenger() {
    return this.addPassengersDetails;
  }
  handleMainPage =(value:boolean) =>{
    this.showMainPage=value;
  }
  get getMainPage() {
    return this.showMainPage;
  }
  handlChangeForm =(value:boolean)=>{
  this.ShowChnageForm =value;
  }
  get getChangeForm(){
    return this.ShowChnageForm;
  }
  handlChangeEditForm =(value:boolean)=>{
    this.ShowChnageEditForm =value;
    }
    get getChangeEditForm(){
      return this.ShowChnageEditForm;
    }
  handlePassengersName=(passengersName:string) =>{
    this.passengersName=passengersName;
  }
  get getPassengersName(){
  return this.passengersName;
  }
  handlePassengersGenger=(gender:string) =>{
    this.passengersGender=gender;
  }
  get getPassengersGender(){
  return this.passengersGender;
  }
  handlePassengersSeatNumber=(SeatNo:any) =>{
    this.passengersSeatNumber=SeatNo;
  }
  get getPassengersSeatNumber(){
  return this.passengersSeatNumber;
  }
  handlePassengerAge=(Age:number) =>{
    this.passengerAge=Age;
  }
  get getPassengerAge(){
  return this.passengerAge;
  }
  handlePassengerEmail=(Email:any) =>{
    this.passengerEmail=Email;
  }
  get getPassengerEmail(){
  return this.passengerEmail;
  }

  handlePassengersContactNumber=(ContactNumber:string) =>{
    this.passengersContactNumber=ContactNumber;
  }
  get getPassengersContactNumber(){
  return this.passengersContactNumber;
  }
  handlePassengerAddress=(Address:any) =>{
    this.passengerAddress=Address;
  }
  get getPassengerAddress(){
  return this.passengerAddress
  }

  
  handlePassengerAnyChronicDisease=(AnyChronicDisease:boolean) =>{
    this.passengerAnyChronicDisease=AnyChronicDisease;
  }
  get getPassengerAnyChronicDisease(){
  return this.passengerAnyChronicDisease
  }
  handlePassengerAnyChronicDisease1=(AnyChronicDisease1:any) =>{
    this.passengerAnyChronicDisease1=AnyChronicDisease1;
  }
  get getPassengerAnyChronicDisease1(){
  return this.passengerAnyChronicDisease1
  }
  handlePassengerPhysicallyDisabled=(PhysicallyDisabled:boolean) =>{
    this.passengerPhysicallyDisabled=PhysicallyDisabled;
  }
  get getPassengerPhysicallyDisabled(){
  return this.passengerPhysicallyDisabled;
  }

  handlePassengerPhysicallyDisabledtxt=(PhysicallyDisabled:any) =>{
    this.passengerPhysicallyDisabledtxt=PhysicallyDisabled;
  }
  get getPassengerPhysicallyDisabledtxt(){
  return this.passengerPhysicallyDisabledtxt;
  }

  handlePassengerInput0=(Input0: boolean) =>{
    this.passengerInput0=Input0;
  }
  get getPassengerInput0(){
  return this.passengerInput0;
  }
  handlePassengerInput00=(Input00:any) =>{
    this.passengerInput00=Input00;
  }
  get getPassengerInput00(){
  return this.passengerInput00;
  }

  handlePassengerInput1=(Input1:any) =>{
    this.passengerInput1=Input1;
  }
  get getPassengerInput1(){
  return this.passengerInput1;
  }
  handlePassengerInput2=(Input2:any) =>{
    this.passengerInput2=Input2;
  }
  get getPassengerInput2(){
  return this.passengerInput2;
  }
  handlePassengerInput3=(Input3:any) =>{
    this.passengerInput3=Input3;
  }
  get getPassengerInput3(){
  return this.passengerInput3;
  }

  handlePassengerInput4=(Input4: string) =>{
    this.passengerInput4=Input4;
  }
  get getPassengerInput4(){
  return this.passengerInput4;
  }
  handlePassengerInput5=(Input5: boolean) =>{
    this.passengerInput5=Input5;
  }
  get getPassengerInput5(){
  return this.passengerInput5;
  }
  handlePassengerInput05=(Input05:any) =>{
    this.passengerInput05=Input05;
  }
  get getPassengerInput05(){
  return this.passengerInput05;
  }
  handlePassengerInput6=(Input6: boolean) =>{
    this.passengerInput6=Input6;
  }
  get getPassengerInput6(){
  return this.passengerInput6;
  }
  handlePassengerInput06=(Input06:any) =>{
    this.passengerInput06=Input06;
  }
  get getPassengerInput06(){
  return this.passengerInput06;
  }


  // for edit passenger
  handleIsEditPassengerOpen = (isOpen: boolean) => {
    this.isEditPassengerOpen = !this.isEditPassengerOpen;
  }
  get getIsEditPassengerOpen() {
    return this.isEditPassengerOpen;
  }
  handleEditPassengersName=(passengersName:string) =>{
    this.EditpassengersName=passengersName;
  }
  get getEditPassengersName(){
  return this.EditpassengersName;
  }
  handleEditPassengersGenger=(gender:any) =>{
    this.EditpassengersGender=gender;
  }
  get getEditPassengersGender(){
  return this.EditpassengersGender;
  }
  handleEditPassengersSeatNumber=(SeatNo:any) =>{
    this.EditpassengersSeatNumber=SeatNo;
  }
  get getEditPassengersSeatNumber(){
  return this.EditpassengersSeatNumber;
  }
  handleEditPassengerAge=(Age:any) =>{
    this.EditpassengerAge=Age;
  }
  get getEditPassengerAge(){
  return this.EditpassengerAge;
  }
  handleEditPassengerEmail=(Email:any) =>{
    this.EditpassengerEmail=Email;
  }
  get getEditPassengerEmail(){
  return this.EditpassengerEmail;
  }

  handleEditPassengersContactNumber=(ContactNumber:string) =>{
    this.EditpassengersContactNumber=ContactNumber;
  }
  get getEditPassengersContactNumber(){
  return this.EditpassengersContactNumber;
  }
  handleEditPassengerAdress=(Adress:string) =>{
    this.EditPassengerAdress=Adress;
  }
  get getEditPassengerAdress(){
  return this.EditPassengerAdress
  }

  handleEditPassengerAnyChronicDisease=(AnyChronicDisease:boolean) =>{
    this.EditpassengerAnyChronicDisease=AnyChronicDisease;
  }
  get getEditPassengerAnyChronicDisease(){
  return this.EditpassengerAnyChronicDisease
  }
  handleEditPassengerAnyChronicDisease1=(AnyChronicDisease1:string) =>{
    this.EditpassengerAnyChronicDisease1=AnyChronicDisease1;
  }
  get getEditPassengerAnyChronicDisease1(){
  return this.EditpassengerAnyChronicDisease1
  }

  handleEditPassengerPhysicallyDisabled=(PhysicallyDisabled:boolean) =>{
    this.EditpassengerPhysicallyDisabled=PhysicallyDisabled;
  }
  get getEditPassengerPhysicallyDisabled(){
  return this.EditpassengerPhysicallyDisabled;
  }

  handleEditPassengerPhysicallyDisabledAns=(PhysicallyDisabled:string) =>{
    this.EditpassengerPhysicallyDisabledans=PhysicallyDisabled;
  }
  get getEditPassengerPhysicallyDisabledAns(){
  return this.EditpassengerPhysicallyDisabledans;
  }
  
  handleEditPassengerInput0=(Input0:boolean) =>{
    this.EditpassengerInput0=Input0;
  }
  get getEditPassengerInput0(){
  return this.EditpassengerInput0;
  }
  handleEditPassengerInput00=(Input00:any) =>{
    this.EditpassengerInput00=Input00;
  }
  get getEditPassengerInput00(){
  return this.EditpassengerInput00;
  }

  handleEditPassengerInput1=(Input1:string) =>{
    this.EditpassengerInput1=Input1;
  }
  get getEditPassengerInput1(){
  return this.EditpassengerInput1;
  }
  handleEditPassengerInput2=(Input2:any) =>{
    this.EditpassengerInput2=Input2;
  }
  get getEditPassengerInput2(){
  return this.EditpassengerInput2;
  }
  handleEditPassengerInput3=(Input3:string) =>{
    this.EditpassengerInput3=Input3;
  }
  get getEditPassengerInput3(){
  return this.EditpassengerInput3;
  }

  handleEditPassengerInput4=(Input4:string) =>{
    this.EditpassengerInput4=Input4;
  }
  get getEditPassengerInput4(){
  return this.EditpassengerInput4;
  }
  handleEditPassengerInput5=(Input5:boolean) =>{
    this.EditpassengerInput5=Input5;
  }
  get getEditPassengerInput5(){
  return this.EditpassengerInput5;
  }
  handleEditPassengerInput05=(Input05:string) =>{
    this.EditpassengerInput05=Input05;
  }
  get getEditPassengerInput05(){
  return this.EditpassengerInput05;
  }
  handleEditPassengerInput6=(Input6:boolean) =>{
    this.EditpassengerInput6=Input6;
  }
  get getEditPassengerInput6(){
  return this.EditpassengerInput6;
  }
  handleEditPassengerInput06=(Input06:string) =>{
    this.EditpassengerInput06=Input06;
  }
  get getEditPassengerInput06(){
  return this.EditpassengerInput06;
  }

  handleCreatePassengerOrgList = (list: OrganizationType[]) => {
    this.createPassengerOrgList = list;
}
get getCreatePassengerOrgList() {
    return this.createPassengerOrgList;
}
handleCreatePassengerOrgList1 = (list1: OrganizationType[]) => {
  this.createPassengerOrgList1 = list1;
}
get getCreatePassengerOrgList1() {
  return this.createPassengerOrgList1;
}
handleSelectedOrgId = (orgId: string) => {
  this.selectedOrgId = orgId;
}
get getSelectedOrgId() {
  return this.selectedOrgId;
}
handleSelectedOrgId1 = (orgId1: string) => {
  this.selectedOrgId1 = orgId1;
}
get getSelectedOrgId1() {
  return this.selectedOrgId1;
}
handlePassengerId = (Id: string) => {
  this.passengerId = Id;
}
get getPassengerId() {
  return this.passengerId;
}

handleupdate = () => {
  this.update++;
}
get getupdate () {
  return this.update ;
}

handlePassengerlist(list : any){
  this.historySearchString = list;
}

get getPassengerlist(){
 return this.historySearchString;
}

handlePassengerLabel = (Passengername: string) => {
  this.PassengerLabel = Passengername;
}
get getPassengerLabel() {
  return this.PassengerLabel;
}

handleOrgList = (list: OrganizationType[]) => {
  this.organizationList = list;
}
get getOrgList() {
  return this.organizationList;
}

handleSelectedOrg = (id: number) => {
  this.selectedOrg = id;
}
get getSelectedOrg() {
  return this.selectedOrg;
}
resetSelectOrg = () => {
  this.selectedOrg = "";
}

handleRoleName = (role: string) => {
  this.roleName = role;
}
get getRolename() {
  return this.roleName;
}
}
